import React from 'react';
import renderHTML from 'react-render-html';

const Required = ({isRequired}) => (isRequired ? (
  <span className="required">*</span>) : (null));

const parseLabel = (text) => {
  if (!text) {
    return null;
  }
  return renderHTML(text);
};

const Label = ({required, label, children, className}) => {
  if (!label || label === '') { return null; }
  return (
    <label className={className}>
      {parseLabel(label)} <Required isRequired={required} /> {children}
    </label>
  )
};

Label.defaultProps = {
  className: 'label-component'
}

export default Label;
